import moment from "moment";
class operaudit {
  constructor(operId, tabla, fecDesde, fecHasta) {
    this.operId = operId;
    this.tabla = tabla;
    this.dateStart = moment(fecDesde, "YYYY-MM-DD").format("DD-MM-YYYY");
    this.dateEnd = fecHasta
      ? moment(fecHasta, "YYYY-MM-DD").format("DD-MM-YYYY")
      : "";
  }
  static fromJson({ operId, tabla, fecDesde, fecHasta }) {
    return new operaudit(operId, tabla, fecDesde, fecHasta);
  }
}
export default operaudit;
